module.exports = __webpack_public_path__ + "static/img/9351_phase_function_Paper_PointsHejduk_Prediction.04047d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9351_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lmD5
// module chunks = 0